/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit XrayIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function XrayIcon({
  children,
  viewPath = "/DesignSystem/Svgs/XrayIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#474747",
  fill2 = "#FFF"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="XrayIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-Zj5eW9': alignSelf,'--mt-2-Zj5eW9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zj5eW9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zj5eW9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zj5eW9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zj5eW9': opacity,'--w-10-Zj5eW9': typeof width === 'number' ? `${width}px` : width,'--h-11-Zj5eW9': typeof height === 'number' ? `${height}px` : height,'--a-7-Zj5eW9': isAnimated ? animation : "none",'--sd-8-Zj5eW9': isAnimated ? strokeDashoffset : 0,'--sd-9-Zj5eW9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="XrayIcon.SvgPath"
  data-view-path={viewPath}
 d="M28 31.8H4C1.9 31.8.2 30.1.2 28V4C.2 1.9 1.9.2 4 .2h24c2.1 0 3.8 1.7 3.8 3.8v24c0 2.1-1.7 3.8-3.8 3.8z"
 style={{'--f-12-Zj5eW9': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="XrayIcon.SvgPath:1"
  data-view-path={viewPath}
 d="M15.9 19.2c-.5 0-.5 1.1-.7 1.7-.3.9-.5 1.8-.8 2.7-.2.8-.5 1.6-1.1 2.2-.7.7-1.7 1-2.5.5-.5-.3-.7-.7-.9-1.2-.4-1-.5-2-.6-3-.1-.8-.1-1.7-.2-2.5-.1-1.1-.6-2.1-1.1-3-.6-.9-1-1.8-1.2-2.9-.3-1.5-.2-2.9.4-4.3.5-1.2 1.3-2.2 2.5-2.8 1.2-.5 2.3-.6 3.5-.5.8.1 1.6.3 2.3.5.3.1.6.1 1 0 1.1-.4 2.2-.6 3.4-.6 1.8.1 3.2.8 4.2 2.3 1.5 2.2 1.5 4.6.5 7-.2.6-.6 1.1-.9 1.6-.6 1-.9 2-1 3.1-.1 1.3-.3 2.6-.4 3.8-.1.6-.3 1.1-.6 1.7-.5.9-1.4 1.1-2.3.8-.7-.2-1.1-.8-1.4-1.4-.5-.8-.7-1.7-.9-2.6-.1-.8-.7-3.1-1.2-3.1z"
 style={{'--f-12-Zj5eW9': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}